var _ellipse, _path, _rect, _rect2, _path2, _path3, _circle, _path4, _path5, _path6, _path7, _circle2, _circle3, _path8, _path9, _path10, _rect3, _rect4, _path11, _path12, _circle4, _path13, _path14, _path15, _path16, _circle5, _circle6, _path17, _path18, _rect5, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _rect6, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _g, _rect7, _g2, _rect8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetworkError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 375.927,
    height: 188.596,
    viewBox: "0 0 375.927 188.596",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0 0)"
  }, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 187.964,
    cy: 11.082,
    rx: 187.964,
    ry: 11.082,
    transform: "translate(0 166.433)",
    fill: "#e2e2e2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M150.819,40.566V45.21h-18.91V40.566a1.2,1.2,0,0,1,.011-.2,5.136,5.136,0,0,1,5.136-4.946h8.626a5.144,5.144,0,0,1,5.136,5.147Z",
    transform: "translate(-25.166 -6.757)",
    fill: "gray"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 11.57,
    height: 127.064,
    transform: "translate(110.413 37.804)",
    fill: "gray"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 35.559,
    height: 9.567,
    transform: "translate(98.419 164.812)",
    fill: "gray"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M157.181,203.668v9.567H139.3a6.85,6.85,0,0,0-6.77-5.751H121.622v-3.815Z",
    transform: "translate(-23.203 -38.856)",
    fill: "#606060"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M150.821,40.566V45.21h-3.67V171.625h-5.8a10.368,10.368,0,0,0-1.79-5.572,10.712,10.712,0,0,0-3.726-3.379c-.09-.045-.168-.089-.258-.134v-10.73h5.785V115.993a10.71,10.71,0,0,0-1.834-6.02,10.57,10.57,0,0,0-3.951-3.514V95.841h5.785V50.67A10.237,10.237,0,0,0,139.8,45.21a4.693,4.693,0,0,0-.436-.649,8.377,8.377,0,0,0-1.052-1.231,10.443,10.443,0,0,0-3.278-2.2,10.231,10.231,0,0,0-3.111-.761,5.136,5.136,0,0,1,5.136-4.946h8.626a5.144,5.144,0,0,1,5.136,5.147Z",
    transform: "translate(-25.169 -6.757)",
    fill: "#606060"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 14.652,
    cy: 14.652,
    r: 14.652,
    transform: "translate(101.677 0)",
    fill: "#8e8e8e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M156.238,25.621a12.488,12.488,0,0,1-3.9,4.233",
    transform: "translate(-29.063 -4.888)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M147.063,32.956a12.472,12.472,0,0,1-2.728.407",
    transform: "translate(-27.536 -6.287)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M131.188,8.936a12.4,12.4,0,0,1,1.152-1.4",
    transform: "translate(-25.028 -1.437)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M135.5,4.688a12.447,12.447,0,0,1,12.822-.322",
    transform: "translate(-25.851 -0.524)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 9.945,
    cy: 9.945,
    r: 9.945,
    transform: "translate(102.313 13.493) rotate(-40.272)",
    fill: "#fffbf2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 6.532,
    cy: 6.532,
    r: 6.532,
    transform: "translate(109.797 8.12)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M139.126,134.09v8.994",
    transform: "translate(-26.543 -25.582)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M139.126,197.555v3.47",
    transform: "translate(-26.543 -37.69)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M328.186,40.566V45.21H309.277V40.566a1.293,1.293,0,0,1,.011-.2,5.136,5.136,0,0,1,5.136-4.946h8.627a5.142,5.142,0,0,1,5.135,5.147Z",
    transform: "translate(-59.004 -6.757)",
    fill: "gray"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    width: 11.57,
    height: 127.064,
    transform: "translate(253.942 37.804)",
    fill: "gray"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    width: 35.559,
    height: 9.567,
    transform: "translate(241.948 164.812)",
    fill: "gray"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M334.548,203.668v9.567h-17.88a6.85,6.85,0,0,0-6.769-5.751h-10.91v-3.815Z",
    transform: "translate(-57.042 -38.856)",
    fill: "#606060"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M328.188,40.566V45.21h-3.67V171.625h-5.8a10.362,10.362,0,0,0-1.791-5.572,10.705,10.705,0,0,0-3.726-3.379c-.09-.045-.167-.089-.257-.134v-10.73h5.785V115.993a10.71,10.71,0,0,0-1.835-6.02,10.574,10.574,0,0,0-3.95-3.514V95.841h5.785V50.67a10.245,10.245,0,0,0-1.567-5.461,4.7,4.7,0,0,0-.437-.649,8.37,8.37,0,0,0-1.051-1.231,10.456,10.456,0,0,0-3.279-2.2,10.225,10.225,0,0,0-3.111-.761,5.136,5.136,0,0,1,5.136-4.946h8.627a5.142,5.142,0,0,1,5.135,5.147Z",
    transform: "translate(-59.007 -6.757)",
    fill: "#606060"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 14.652,
    cy: 14.652,
    r: 14.652,
    transform: "translate(245.206 0)",
    fill: "#8e8e8e"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M333.6,25.621a12.494,12.494,0,0,1-3.9,4.233",
    transform: "translate(-62.901 -4.888)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M324.43,32.956a12.464,12.464,0,0,1-2.728.407",
    transform: "translate(-61.375 -6.287)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M308.556,8.936a12.387,12.387,0,0,1,1.152-1.4",
    transform: "translate(-58.867 -1.437)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M312.87,4.688a12.447,12.447,0,0,1,12.822-.322",
    transform: "translate(-59.69 -0.524)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 9.945,
    cy: 9.945,
    r: 9.945,
    transform: "translate(247.75 21.807) rotate(-75.58)",
    fill: "#fffbf2"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 6.532,
    cy: 6.532,
    r: 6.532,
    transform: "translate(253.326 8.12)",
    fill: "#fff8eb"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M316.493,134.09v8.994",
    transform: "translate(-60.381 -25.582)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M316.493,197.555v3.47",
    transform: "translate(-60.381 -37.69)",
    fill: "none",
    stroke: "#b7b7b7",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(91.294 122.002)"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 193.338,
    height: 28.074,
    transform: "translate(0 0)",
    fill: "#fffbf2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M134.144,150.765l-21.327,21.371v-11.48l9.869-9.891Z",
    transform: "translate(-112.817 -150.765)",
    fill: "#8e8e8e"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M157.6,150.765l-28.018,28.074H118.113l28.018-28.074Z",
    transform: "translate(-113.827 -150.765)",
    fill: "#8e8e8e"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M185.326,150.765l-28.018,28.074H145.85l28.018-28.074Z",
    transform: "translate(-119.119 -150.765)",
    fill: "#8e8e8e"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M213.06,150.765l-28.018,28.074H173.574l28.018-28.074Z",
    transform: "translate(-124.408 -150.765)",
    fill: "#8e8e8e"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M240.8,150.765,212.78,178.839H201.311l28.018-28.074Z",
    transform: "translate(-129.7 -150.765)",
    fill: "#8e8e8e"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M268.521,150.765,240.5,178.839H229.034l28.018-28.074Z",
    transform: "translate(-134.989 -150.765)",
    fill: "#8e8e8e"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M296.258,150.765,268.24,178.839H256.772l28.018-28.074Z",
    transform: "translate(-140.281 -150.765)",
    fill: "#8e8e8e"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M323.984,150.765l-28.018,28.074H284.509l28.018-28.074Z",
    transform: "translate(-145.573 -150.765)",
    fill: "#8e8e8e"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M344.2,150.765v7.542l-20.5,20.532H312.232l28.018-28.074Z",
    transform: "translate(-150.862 -150.765)",
    fill: "#8e8e8e"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M349.491,173.663v9.544h-9.522Z",
    transform: "translate(-156.154 -155.134)",
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M306.155,150.765v28.074H249.818a62.512,62.512,0,0,0-45.842-19.917H112.817v-8.157Z",
    transform: "translate(-112.817 -150.765)",
    fill: "#606060",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 193.338,
    height: 56.135,
    transform: "translate(91.296 37.801)",
    fill: "#fffbf2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M146.653,46.716l-33.836,33.9V62.56l15.822-15.844Z",
    transform: "translate(-21.524 -8.913)",
    fill: "#8e8e8e"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M182.694,46.716,126.67,102.852H112.817V98.668l51.851-51.951Z",
    transform: "translate(-21.524 -8.913)",
    fill: "#8e8e8e"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M226.236,46.716l-56.024,56.136H152.2l56.024-56.136Z",
    transform: "translate(-29.036 -8.913)",
    fill: "#8e8e8e"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M270.773,46.716l-56.024,56.136H196.734l56.024-56.136Z",
    transform: "translate(-37.533 -8.913)",
    fill: "#8e8e8e"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M315.307,46.716l-56.024,56.136H241.258l56.024-56.136Z",
    transform: "translate(-46.028 -8.913)",
    fill: "#8e8e8e"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M339.156,50.007V68.055L303.809,103.48H285.795Z",
    transform: "translate(-54.524 -9.54)",
    fill: "#8e8e8e"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M348.093,96.95v15.486H332.641Z",
    transform: "translate(-63.462 -18.496)",
    fill: "#8e8e8e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M217.552,102.194h-90.3a5.626,5.626,0,0,1-5.626-5.626h0a5.626,5.626,0,0,1,5.626-5.626h90.3a5.627,5.627,0,0,1,5.625,5.626h0A5.625,5.625,0,0,1,217.552,102.194Z",
    transform: "translate(-23.203 -17.35)",
    fill: "#fffbf2",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M195.167,177.962H127.248a5.626,5.626,0,0,1-5.626-5.626h0a5.626,5.626,0,0,1,5.626-5.626h67.919a5.626,5.626,0,0,1,5.626,5.626h0A5.626,5.626,0,0,1,195.167,177.962Z",
    transform: "translate(-23.203 -31.805)",
    fill: "#fffbf2",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(22.302 92.059)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(265.39)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(9.937 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M413.86,186.569H367.8l3.455-13.344,2.913-11.321,2.436-9.4,2.913-11.313,7.089-27.433h8.448l7.081,27.433,2.921,11.313,2.428,9.4,2.921,11.321Z",
    transform: "translate(-367.799 -113.763)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M407.129,158.977H378.678l2.916-11.317h22.62Z",
    transform: "translate(-369.874 -120.23)",
    fill: "#fffbf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M411.216,184.574H372.069l2.916-11.317H408.3Z",
    transform: "translate(-368.614 -125.114)",
    fill: "#fffbf2"
  }))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 65.933,
    height: 9.567,
    transform: "translate(0 72.753)",
    fill: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M421.452,203.668v9.567H391.516a6.85,6.85,0,0,0-6.77-5.751H355.519v-3.815Z",
    transform: "translate(-355.519 -130.915)",
    fill: "#606060",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M396.606,186.568c9.856-44.636-5.567-72.805-5.567-72.805h8.448l7.081,27.432,2.921,11.313,2.428,9.4,2.921,11.321,3.455,13.344Z",
    transform: "translate(-362.295 -113.763)",
    fill: "#606060",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M390.108,161.826c-2.294,11.833-5.94,21.079-8.142,20.652s-2.127-10.365.167-22.2,5.94-21.079,8.142-20.652S392.4,149.993,390.108,161.826Z",
    transform: "translate(-360.258 -118.695)",
    fill: "#fffbf2",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(9.938 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M85.9,186.569H39.841L43.3,173.225,46.209,161.9l2.436-9.4L51.558,141.2l7.089-27.433H67.1L74.176,141.2,77.1,152.509l2.428,9.4,2.921,11.321Z",
    transform: "translate(-39.841 -113.763)",
    fill: "#8e8e8e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M79.171,158.977H50.719l2.916-11.317h22.62Z",
    transform: "translate(-41.916 -120.23)",
    fill: "#fffbf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M83.258,184.574H44.111l2.916-11.317H80.342Z",
    transform: "translate(-40.655 -125.114)",
    fill: "#fffbf2"
  }))), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    width: 65.933,
    height: 9.567,
    transform: "translate(0 72.753)",
    fill: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M93.493,203.668v9.567H63.557a6.85,6.85,0,0,0-6.769-5.751H27.56v-3.815Z",
    transform: "translate(-27.56 -130.915)",
    fill: "#606060",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M68.648,186.568c9.856-44.636-5.567-72.805-5.567-72.805h8.448L78.61,141.2l2.921,11.313,2.428,9.4,2.92,11.321,3.456,13.344Z",
    transform: "translate(-34.337 -113.763)",
    fill: "#606060",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M62.15,161.826c-2.295,11.833-5.94,21.079-8.142,20.652s-2.127-10.365.168-22.2,5.94-21.079,8.142-20.652S64.444,149.993,62.15,161.826Z",
    transform: "translate(-32.3 -118.695)",
    fill: "#fffbf2",
    opacity: 0.3,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkError);
export default __webpack_public_path__ + "static/media/network-error.8ebdb6ad914218ff27a64570f6fc35a1.svg";
export { ForwardRef as ReactComponent };